export const WEB_DISABLED_ERROR =
  "You do not have permission to use the Agent Panel. Please contact your administrator."
export const CC_BLOCKED_ERROR = "Your contact center is blocked."
export const HUBSPOT_DISABLED_ERROR = "HubSpot integration is not enabled for your contact center."
export const AUTH_FAILED_ERROR = "Enter a valid email and password"
export const NO_ACCESS_ERROR =
  "Sign-in unavailable. None of your accounts can be accessed. Ask your administrator to review your sign-in account or contact center permissions."
export const GOOGLE_SIGN_IN_FAILED_ERROR =
  "This user does not exist in your contact center. Please ask your system administrator to create this user, then try again."
export const GOOGLE_SIGN_IN_DISABLED_ERROR =
  "Google sign-in is not enabled for your contact center. Please sign in using your username and password."
